import {saveState} from "@utils/util";
import {KEEP_FEELINGS_TOGGLED} from "@utils/storageKeys";

export const state = {
    activeItems: [],
    keepFeelingsToggled: localStorage.getItem(KEEP_FEELINGS_TOGGLED) === 'true',
    smartPromptsOpen: false,
    // Active client-card tab hash. Tabs switch via history.pushState, which
    // bypasses vue-router, so $route.hash is not reactive — the smart-prompts
    // panel reads this instead to pick the per-tab context.
    athleteTab: null,
}

export const getters = {};

export const mutations = {

    setSmartPromptsOpen(state, value){
        state.smartPromptsOpen = !!value;
    },

    toggleSmartPrompts(state){
        state.smartPromptsOpen = !state.smartPromptsOpen;
    },

    setAthleteTab(state, value){
        state.athleteTab = value;
    },

    setActiveItem(state, item){
        let items = [...state.activeItems];


        if(item.index === 0){
            state.activeItems = [item.value]
            return;
        }
        // replace or push to array.
        if(items.length > item.index + 1){
            items.push(item.value);
        }else{
            items[item.index] = item.value;
        }

        // re-assignment here to trigger an update on component instead of direct editing!
        state.activeItems = items;
    },

    SET_KEEP_FEELINGS_TOGGLED(state, value) {
        state.keepFeelingsToggled = value;
        saveState(KEEP_FEELINGS_TOGGLED, value);
    }
}